// extracted by mini-css-extract-plugin
export default {"container":"Place_container__JVIlQ","image":"Place_image__K3r1s","textContent":"Place_textContent__OU2OX","buttonContainer":"Place_buttonContainer__F6xj1"};